import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid main-wrapper d-flex justify-content-between" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "d-none d-xl-block"
}
const _hoisted_5 = {
  class: "collapse navbar-collapse d-md-flexjustify-content-md-end",
  id: "navbarText"
}
const _hoisted_6 = {
  class: "navbar-nav mb-2 mb-lg-0",
  style: {"margin-right":"6.5px"}
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_14 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_15 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_18 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_19 = {
  key: 8,
  class: "nav-item"
}

import { isAdminUser, normalizeResourcePath } from "@/guiide/ts/utilities";
    import View from "@/guiide/ts/view";
    import { ref, computed } from "vue";
    import { useStore } from "vuex";
    import Modal from "@/guiide/components/common/Modal.vue";
    import UserSettingsEditor from "@/guiide/components/userSettings/UserSettingsEditor.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

    const store = useStore();

    const userSettingsModal = ref<any>(null);

    const isInWorkflow = computed<boolean>(() => {
        const workflowViews = [
            View.UserHome,
            View.You,
            View.Requirements,
            View.Haves,
            View.Life,
            View.Design,
            View.Test,
            View.Finish,
            View.DBOptions,
            View.Support
        ];
        return workflowViews.includes(store.state.view);
    });

    const showAdminBar = computed<boolean>(() => isAdminUser());

    const parentCompanyLink = computed<string>(() => store.state.configuration.parentCompanyLink);

    const title = computed<string>(() => store.state.configuration.title);

    const showTitle = computed<boolean>(() => store.state.configuration.displayTitleInWorkflow);

    const showTrack = computed<boolean>(() =>
        isInWorkflow.value && store.state.configuration.nav.track.available
    );

    const trackEnabled = computed<boolean>(() => {
        if (store.state.retiree == null) return false;
        if (store.state.configuration.finishDisplaysNextButton) return true;
        return store.state.retiree.isRegistered;
    });

    const trackResource = computed<string>(() =>
        normalizeResourcePath(store.state.configuration.nav.track.resource)
    );

    const showPlan = computed<boolean>(() => !isInWorkflow.value);

    const planEnabled = computed<boolean>(() => !isInWorkflow.value);

    const showOptions = computed<boolean>(() => false); // store.state.configuration.nav.options.available

    const optionsEnabled = computed<boolean>(() => true);

    const homeResource = computed<string>(() =>
        normalizeResourcePath(store.state.configuration.nav.home.resource)
    );

    const showStart = computed<boolean>(() =>
        isInWorkflow.value && store.state.configuration.nav.start.available
    );

    const startEnabled = computed<boolean>(() => true);

    const showDesign = computed<boolean>(() =>
        isInWorkflow.value && store.state.configuration.nav.design.available
    );

    const designEnabled = computed<boolean>(() => true);

    const trackActive = computed<boolean>(() => false);
    const planActive = computed<boolean>(() => false);
    const homeActive = computed<boolean>(() => false);
    const startActive = computed<boolean>(() => false);

    const designActive = computed<boolean>(() => showStart.value);

    const optionsActive = computed<boolean>(() => false);

    const showLogin = computed<boolean>(() =>
        isInWorkflow.value && store.state.configuration.nav.login.available
    );

    const loginActive = computed<boolean>(() => true);

    const loginResource = computed<string>(() =>
        normalizeResourcePath(store.state.configuration.nav.login.resource)
    );

    const site = computed<string>(() => store.state.configuration.site);

    const showUserSettings = computed<boolean>(() => {
        if (store.state.retiree == null) {
            return false;
        }
        
        return (
            store.state.configuration.showUserSettings &&
            store.state.retiree.alreadyDrawingPension &&
            store.state.retiree.isRegistered
        );
    });

    const userSettingsActive = computed<boolean>(() => false);

    const showLogout = computed<boolean>(() => {
        if (store.state.retiree == null) {
            return false;
        }

        return (
            store.state.configuration.showLogout &&
            isInWorkflow.value &&
            !store.state.configuration.nav.login.available
        );
    });

    const logoutActive = computed<boolean>(() => false);

    const showGetSupport = computed<boolean>(() => {
        if (store.state.retiree == null) {
            return false;
        }

        return (
            store.state.configuration.showGetSupport &&
            isInWorkflow.value
        );
    });

    const getSupportActive = computed<boolean>(() => false);

    const openUserSettingsModal = () => {
        userSettingsModal.value?.showModal();
    };

    const onUserSettingsExit = () => {
        userSettingsModal.value?.closeModal();
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navbar navbar-expand-md navbar-primary navbar-light mx-auto pt-md-4 mb-md-4 px-md-2 col-lg-10 py-0", { 'navbar-drop': showAdminBar.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "navbar-brand skin-navbar-brand",
          target: "_blank",
          href: parentCompanyLink.value,
          style: _normalizeStyle(parentCompanyLink.value === '' ? 'pointer-events: none;' : '')
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(site.value) + " logo", 1)
        ], 12, _hoisted_2),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          class: "navbar-toggler border-0 fs-6",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarText",
          "aria-controls": "navbarText",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, [
          _createElementVNode("span", { class: "navbar-toggler-icon" })
        ], -1)),
        (showTitle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(title.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: homeActive.value }]),
                href: homeResource.value
              }, "Home", 10, _hoisted_8)
            ]),
            (showStart.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: !startEnabled.value, active: startActive.value }]),
                    href: "/home/userhome"
                  }, "Start", 2)
                ]))
              : _createCommentVNode("", true),
            (showDesign.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: !designEnabled.value, active: designActive.value }]),
                    href: "/home/startdesign"
                  }, "Design", 2)
                ]))
              : _createCommentVNode("", true),
            (showTrack.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: !trackEnabled.value, active: trackActive.value }]),
                    href: trackResource.value
                  }, "Track", 10, _hoisted_12)
                ]))
              : _createCommentVNode("", true),
            (showPlan.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: !planEnabled.value, active: planActive.value }]),
                    href: "/finish"
                  }, "Plan", 2)
                ]))
              : _createCommentVNode("", true),
            (showOptions.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: !optionsEnabled.value, active: optionsActive.value }]),
                    href: "/options"
                  }, "Options", 2)
                ]))
              : _createCommentVNode("", true),
            (showLogin.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { disabled: false, active: false }]),
                    href: loginResource.value
                  }, "Log In", 8, _hoisted_16)
                ]))
              : _createCommentVNode("", true),
            (showUserSettings.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: userSettingsActive.value }]),
                    onClick: openUserSettingsModal
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "bi bi-gear" }, null, -1)
                  ]), 2)
                ]))
              : _createCommentVNode("", true),
            (showGetSupport.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: getSupportActive.value }]),
                    href: "/support"
                  }, "Get support", 2)
                ]))
              : _createCommentVNode("", true),
            (showLogout.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: logoutActive.value }]),
                    href: "/logoff"
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1)
                  ]), 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createVNode(Modal, {
      title: "User Settings",
      ref_key: "userSettingsModal",
      ref: userSettingsModal,
      idKey: "userSettings",
      isWide: true,
      hideHeader: true
    }, {
      default: _withCtx(() => [
        _createVNode(UserSettingsEditor, {
          ref: "userSettingsEditor",
          onExit: onUserSettingsExit
        }, null, 512)
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})